import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LoginForm from 'components/authentication/LoginForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useTranslation, Trans } from 'react-i18next';
import AppContext from 'context/Context';
const Login = () => {
  const { t } = useTranslation('auth');
  const {
    config: { corp }
  } = useContext(AppContext);
  return (
    <AuthCardLayout
      leftSideContent={
        corp == 'y4' ? (
          <p className="text-white">
            <Trans ns="auth">Don't have an account?</Trans>
            <br />
            <Link
              className="text-white text-decoration-underline"
              to={`/${corp}/authentication/card/register`}
            >
              {t('Get started!')}
            </Link>
          </p>
        ) : null
      }
    >
      <h3>{t('Account Login')}</h3>
      <LoginForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default Login;
